"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ViewClient = void 0;
const BaseClient_1 = require("../BaseClient");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
class ViewClient extends BaseClient_1.BaseClient {
    constructor(view, baseUrl, tokenProvider) {
        super(baseUrl, tokenProvider);
        this.view = view;
    }
    async list(request) {
        const response = await this.axiosInstance({
            method: 'POST',
            url: '/api/v1/view/list',
            data: {
                ...request,
                view: this.view,
            },
        });
        return response.data;
    }
    /**
     * Convenience method to get count of rows by filter
     */
    async count(request) {
        const response = await this.list({ filter: request.filter, limit: 0 });
        return response.total;
    }
}
exports.ViewClient = ViewClient;
